<template>
  <app-layout>
    <div class="px-12">
      <bread-nav :pages="pages"></bread-nav>
    </div>

    <div>
      <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
        <div class="bg-blue-50 border-l-4 border-blue-400 p-4 mb-2" role="alert" v-if="this.$page.props.user.current_team_id === null">
          <p class="text-red-700 font-bold">Tips:</p>
          <p class="text-gray-500 font-bold text-lg">- Team feature is required for accessing Async Report, Planning Poker (Team) and Retrospective (Team) .</p>
          <p class="text-gray-500 font-bold text-lg">- You do not need to invite team member manually to your team, the system will pop up a member join notification for you when they access team boards.</p>
          <p class="text-gray-500 font-bold text-lg">- For Slack Async Report, your team member will be added based on report participants.</p>
          <p class="text-gray-500 font-bold text-lg">- You can always check Seat Usage page to understand team details.</p>
          <p class="text-gray-500 font-bold text-lg">- For premium account, all your teams will become premium that means any member in your team can have the same access to all subscribed features.</p>
        </div>
        <create-team-form/>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import CreateTeamForm from './CreateTeamForm'
import BreadNav from "@/Components/BreadNav/BreadNav";

const pages = [
  {name: 'Team Management', href: '#', current: false},
  {name: 'Create Team', href: '#', current: true},
]
export default {
  components: {
    BreadNav,
    AppLayout,
    CreateTeamForm,
  },
  setup() {
    return {
      pages
    }
  }
}
</script>
